<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import TaskForm from './TaskForm.vue';
    import DialogForm from '@/components/DialogForm.vue';
    import QueryKey from '@/enums/QueryKey';
    import type { Company } from '@/types';
    import { Button } from '@/components/ui/button';
    import { DialogFooter, DialogClose } from '@/components/ui/dialog';
    import { useI18n } from 'vue-i18n';
    import Permission from '@/enums/Permission';
    import { usePermissions } from '@/composables/usePermissions';

    const props = defineProps<{
        company: Company;
    }>();

    const { t } = useI18n();
    const { hasAnyPermission } = usePermissions();

    const form = useForm({
        company_id: props.company.id,
        task_title: '',
        task_description: '',
        deadline: '',
        weekdays: [],
        task_status: 'Open',
        send_notification: 0,
        notification_recurring_week: '0',
        notification_recurring_even_week: '1',
        notification_recurring_start_of_month: '1',
        responsible_ids: [],
        filename: null,
    });
</script>

<template>
    <DialogForm
        type="create"
        :form="form"
        :route="route('v2.dashboard.tasks.create')"
        :query-key="[QueryKey.DASHBOARD_TASKS, props.company.id]"
        title="dashboards.tasks_create"
        button-text="dashboards.tasks_create"
        submit-text="dashboards.tasks_create"
    >
        <TaskForm :form="form" />

        <template #footer>
            <DialogFooter class="gap-2 border-t sm:justify-center">
                <DialogClose as-child>
                    <Button
                        variant="outline"
                        size="sm"
                        @click="form.resetAndClearErrors()"
                    >
                        {{ $t('forms.cancel') }}
                    </Button>
                </DialogClose>

                <Button
                    v-if="
                        hasAnyPermission([
                            Permission.DASHBOARD_ADMIN_CREATE,
                            Permission.DASHBOARD_ADMIN_UPDATE,
                        ])
                    "
                    :disabled="form.processing"
                    :loading="form.processing"
                    size="sm"
                    variant="default"
                >
                    {{ t('dashboards.tasks_create') }}
                </Button>
            </DialogFooter>
        </template>
    </DialogForm>
</template>
